module.exports = __webpack_public_path__ + "static/img/pause.0c82bfb9.png";